// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__8QrOH","label":"CategoryService_label__R8E-z","location":"CategoryService_location__24OQD"};